<app-order-preparation-page [order]="data.order"
                            (confirmed)="onConfirmed()"></app-order-preparation-page>
